import DriveContainer from '../components/drive/DriveContainer'

export default [
  {
    path: 'folders/:folderId',
    element: <DriveContainer />
  },
  {
    path: 'recent',
    element: <DriveContainer section='recent' />
  },
  {
    path: 'starred',
    element: <DriveContainer section='starred' />
  },
  {
    path: 'trash',
    element: <DriveContainer section='trash' />
  },
  {
    path: 'locked',
    element: <DriveContainer section='locked' />
  },
  {
    path: 'locked/folders/:folderId',
    element: <DriveContainer section='locked' />
  }
]
